import store from '@/store'
import wsCmd from '@/plugins/wsCmd'
import {toWebsocketData} from '@/utils/websocketutils'

export function getToken(data) {
    let _data = toWebsocketData(wsCmd.cmd_98,data)
    return store.dispatch('websocket/sendObj',_data)
}
